// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Styles for the message content with copy button */
.message-content {
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.message-text {
  flex-grow: 1;
}

.copy-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  margin-left: 8px;
  border-radius: 4px;
  opacity: 0.6;
  transition: opacity 0.2s, background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.copy-button:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.05);
}

.message.bot .copy-button {
  color: #4a5568;
}

.message.user .copy-button {
  color: #fff;
}

/* Make copy button visible only on hover for a cleaner UI */
.message-content .copy-button {
  opacity: 0;
}

.message-content:hover .copy-button {
  opacity: 0.6;
}

/* Styles for the system prompt section */
.system-prompt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.reset-prompt-button {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.reset-prompt-button:hover {
  background-color: #e0e0e0;
}

.prompt-help-text {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Styles for the message content with copy button */\n.message-content {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.message-text {\n  flex-grow: 1;\n}\n\n.copy-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  margin-left: 8px;\n  border-radius: 4px;\n  opacity: 0.6;\n  transition: opacity 0.2s, background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n}\n\n.copy-button:hover {\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.message.bot .copy-button {\n  color: #4a5568;\n}\n\n.message.user .copy-button {\n  color: #fff;\n}\n\n/* Make copy button visible only on hover for a cleaner UI */\n.message-content .copy-button {\n  opacity: 0;\n}\n\n.message-content:hover .copy-button {\n  opacity: 0.6;\n}\n\n/* Styles for the system prompt section */\n.system-prompt-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.reset-prompt-button {\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.reset-prompt-button:hover {\n  background-color: #e0e0e0;\n}\n\n.prompt-help-text {\n  font-size: 12px;\n  color: #666;\n  margin-top: 5px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
